import { EndNodeTypeSettings } from "./EndNode";

function EndNodeSettings(props) {
  const { node } = props;

  return EndNodeTypeSettings[node?.data?.settings?.endNodeType]({
    ...props,
  });
}

export { EndNodeSettings };
